export default "__VITE_ASSET__OEkyPbiP__"